import React from 'react';

const MagnifyingGlassIcon = () => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round">
        <circle cx="10.5" cy="10.5" r="7.5" />
        <line x1="21" y1="21" x2="15.8" y2="15.8" />
    </svg>
);

export default MagnifyingGlassIcon;